<template>
  <div class="index-workbench">
    <el-dialog
      title="确认清空"
      custom-class="index-workbench-dialog"
      v-model="isShowComfirmClearCurSene"
      width="380px"
      top="30vh"
      :show-close="false"
    >
      <span>是否清空当前场景所有组件？</span>
      <template #footer>
        <span class="dialog-footer">
          <div class="dialog-footer-btns">
            <el-button size="mini" @click="isShowComfirmClearCurSene = false">取 消</el-button>
            <el-button size="mini" @click="clearCurSeneComponents">确 定</el-button>
          </div>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      title="添加至模板"
      custom-class="index-workbench-addTemplate-dialog"
      v-model="isShowComfirmAddToTemplate"
      width="380px"
      top="30vh"
      :show-close="false"
    >
      <div class="add-template-info">
        <div class="add-template-info-item">
          <span class="info-label">模板名称：</span>
          <span class="info-value">
            <el-input v-model="templateName" type="text" maxlength="20" size="mini"></el-input>
          </span>
        </div>
        <div class="add-template-info-item">
          <span class="info-label">是否公开：</span>
          <span class="info-value">
            <el-radio-group v-model="templateType">
              <el-radio :label="1">私有</el-radio>
              <el-radio :label="2">公开</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div class="add-template-info-item">
          <span class="info-label">封面上传：</span>
          <span class="info-value">
            <ImageUpload
              :imgsrc="templateImageUrl"
              filedname="image"
              @update:imgsrc="val => (templateImageUrl = val)"
            />
          </span>
        </div>
        <div class="add-template-info-item">
          <span class="info-label">访问权限：</span>
          <span class="info-value">
            <el-input
              v-model="templateAuth"
              placeholder="英文逗号分隔，为空允许任何权限访问。"
              type="text"
              maxlength="200"
              size="mini"
            ></el-input>
          </span>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <div class="dialog-footer-btns">
            <el-button size="mini" @click="isShowComfirmAddToTemplate = false">取 消</el-button>
            <el-button size="mini" @click="handleAddToTemplate">确 定</el-button>
          </div>
        </span>
      </template>
    </el-dialog>

    <div class="workbench-header">
      <div class="workbench-size-controller">
        <el-tooltip class="item" effect="dark" content="添加到模板" placement="bottom">
          <i class="el-icon-star-on controller_component_btn" @click="isShowComfirmAddToTemplate = true"></i>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="清空场景" placement="bottom">
          <i class="el-icon-delete controller_component_btn" @click="isShowComfirmClearCurSene = true"></i>
        </el-tooltip>

        <i class="el-icon-minus screen_sizeRatio_minus_btn" @click="handleScreenSizeRatioMinus"></i>
        <div class="screen_sizeRatio_info">{{ screen_sizeRatio }}%</div>
        <i class="el-icon-plus screen_sizeRatio_plus_btn" @click="handleScreenSizeRatioPlus"></i>

        <el-tooltip class="item" effect="dark" content="适应屏幕" placement="bottom">
          <i class="el-icon-monitor screen_autofit_btn" @click="autoFitScreenSize"></i>
        </el-tooltip>

        <el-autocomplete
          popper-class="screen_size_popper"
          :fetch-suggestions="screenWidthQuerySearch"
          v-model="screen_width"
          placeholder="请输入"
        ></el-autocomplete>
        <i class="el-icon-close"></i>
        <el-autocomplete
          popper-class="screen_size_popper"
          :fetch-suggestions="screenHeightQuerySearch"
          v-model="screen_height"
          placeholder="请输入"
        ></el-autocomplete>
        <el-tooltip
          class="item"
          effect="dark"
          :content="`本屏幕尺寸 ${ClientViewSize.width} * ${ClientViewSize.height}`"
          placement="right"
        >
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
    </div>
    <div class="workbench-body" id="workbench-body">
      <div class="workbench-rule-component">
        <div
          class="workbench-ruler-top"
          @click="handleAddGuideLinesTop($event)"
          @mousemove="handleWorkbenchTopRulerHover($event)"
          @mouseleave="handle_workbench_ruler_hove_end"
          :style="ruler_top_pos_style"
        >
          <div
            class="rule-scale-top-item"
            :style="{ width: workbench_rule_unit_long + 'px' }"
            v-for="(item, index) in ruler_top_scales_arr"
            :key="index"
          >
            <p>{{ item }}</p>
          </div>
        </div>
        <div
          class="workbench-ruler-left"
          @click="handleAddGuideLinesLeft($event)"
          @mousemove="handleWorkbenchLeftRulerHover($event)"
          @mouseleave="handle_workbench_ruler_hove_end"
          :style="ruler_left_pos_style"
        >
          <div
            class="rule-scale-left-item"
            :style="{ height: workbench_rule_unit_long + 'px' }"
            v-for="(item, index) in ruler_left_scales_arr"
            :key="index"
          >
            <p>{{ item }}</p>
          </div>
        </div>

        <div class="workbench-dash">
          <div
            class="workbench-dash-top-item"
            :style="item.style"
            :class="{ ban: isPrevent_guideLine_move, guide_line_hide: isHide_guideLines }"
            @mousedown="moveGuideLine($event, item.id)"
            @dblclick="removeGuideLine(item.id)"
            v-for="(item, index) in guide_lines_sets.top"
            :key="index"
          >
            <i class="top-ruler-maker">{{ item.markerNum }}</i>
          </div>
          <div
            class="workbench-dash-left-item"
            :style="item.style"
            :class="{ ban: isPrevent_guideLine_move, guide_line_hide: isHide_guideLines }"
            @mousedown="moveGuideLine($event, item.id)"
            @dblclick="removeGuideLine(item.id)"
            v-for="(item, index) in guide_lines_sets.left"
            :key="index"
          >
            <i class="left-ruler-maker">{{ item.markerNum }}</i>
          </div>
          <div
            class="workbench-dash-top-hover-item"
            v-if="isShow_DotsHoverLine_top"
            :style="dotsHoverLine_topStyle"
          >
            <i class="top-ruler-maker">{{ dotsHoverLine_topStyle.markerNum }}</i>
          </div>
          <div
            class="workbench-dash-left-hover-item"
            v-if="isShow_DotsHoverLine_left"
            :style="dotsHoverLine_leftStyle"
          >
            <i class="left-ruler-maker">{{ dotsHoverLine_leftStyle.markerNum }}</i>
          </div>
        </div>
        <div class="workbench-ruler-manger">
          <el-tooltip
            class="item"
            effect="dark"
            :content="isHide_guideLines ? '显示辅助线' : '隐藏辅助线'"
            placement="top-start"
          >
            <i
              class="hide-guide-line-btn el-icon-view"
              @click="toggleHideGuideLines"
              :class="{ close: isHide_guideLines }"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="isPrevent_guideLine_move ? '解锁辅助线' : '锁定辅助线'"
            placement="top-start"
          >
            <i
              class="lock-guide-line-btn el-icon-goods"
              @click="toggleLockGuideLinesMove"
              :class="{ close: !isPrevent_guideLine_move }"
            ></i>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="删除所有辅助线" placement="top-start">
            <i class="delete-guide-line-btn el-icon-delete-solid" @click="emptyGuideLines"></i>
          </el-tooltip>
        </div>
      </div>

      <div v-if="screenMobile" class="screen-wrapper-outer-mobile" id="screen-wrapper-outer">
        <div class="screen-wrapper-mobile">
          <screen
            :ProjectInfo="$store.state.ProjectInfo"
            class="screen-mobile"
            :style="getCurrentScreenMobileSize()"
          ></screen>
        </div>
      </div>
      <div v-else class="screen-wrapper-outer" id="screen-wrapper-outer">
        <div class="screen-wrapper">
          <screen :ProjectInfo="$store.state.ProjectInfo" :style="getCurrentScreenSize()"></screen>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex';
// import html2canvas from 'html2canvas';
import Screen from '@/views/commonviews/Screen.vue';
import { request } from '../../common/request';
import Api from '../../apis/api';
import ImageUpload from '../ImagesUpload/ImageUpload.vue';
export default {
  name: 'IndexWorkbench',
  components: {
    Screen,
    ImageUpload,
  },
  props: {
    is_open_right_menu: Boolean,
    is_open_left_menu: Boolean,
    asyncProjectInfo: Object,
  },
  data() {
    return {
      templateType: 1,
      templateAuth: '',
      templateName: '',
      isShowComfirmAddToTemplate: false,
      isShowComfirmClearCurSene: false,
      isProtectLoalGuideLines: true,
      screen_width: 1920,
      screen_height: 1080,
      screen_sizeRatio: 100,
      screen_wrapper_outer_scrollTop: 0,
      screen_wrapper_outer_scrollLeft: 0,
      workbench_rule_unit_long: 100,
      ruler_top_scales_arr: [],
      ruler_left_scales_arr: [],
      ruler_top_pos_style: {},
      ruler_left_pos_style: {},
      dotsHoverLine_topStyle: {},
      dotsHoverLine_leftStyle: {},
      guide_lines_sets: {
        top: [],
        left: [],
      },
      isShow_DotsHoverLine_top: false,
      isShow_DotsHoverLine_left: false,
      isPrevent_guideLine_move: false,
      isHide_guideLines: false,
      debounceAutoFitTimerId: null,
      screenMobile: false,
      templateImageUrl: '',
      userInfo: {},
    };
  },
  created() {
    this.$eventBus.on('imgUploaded', this.handleImageUploaded);
    this.$eventBus.on('imgRemoved', this.handleImageRemoved);
  },
  mounted() {
    this.$nextTick(() => {
      this.loadLocalGuideLines();
      this.setRuler();
      this.setRulePosition();
      // this.autoFitScreenSize();
      this.updateScreenWrapperOuterFullSize();
    });
    console.log(this.screenMobile, 'screenMobile');
    this.screen_width = this.ProjectInfo.ScreenSize.width;
    this.screen_height = this.ProjectInfo.ScreenSize.height;
    this.screen_sizeRatio = this.ProjectInfo.ScreenRatio.w_Ratio;
    window.addEventListener('resize', this.onResize);
    this.userInfo = JSON.parse(localStorage.getItem('origin_userInfo'));
    console.log(this.userInfo, 'svsvs');
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    this.$eventBus.off('imgUploaded', this.handleImageUploaded);
    this.$eventBus.off('imgRemoved', this.handleImageRemoved);
  },
  watch: {
    asyncProjectInfo: {
      deep: true,
      handler: function () {
        this.screen_width = this.ProjectInfo.ScreenSize.width;
        this.screen_height = this.ProjectInfo.ScreenSize.height;
        this.screen_sizeRatio = this.ProjectInfo.ScreenRatio.w_Ratio;
      },
    },
    isMobile: {
      deep: true,
      handler: function (vn, vo) {
        this.screenMobile = vn;
        this.updateScreenWrapperOuterFullSize();
      },
    },
    is_open_right_menu() {
      setTimeout(() => {
        this.updateScreenWrapperOuterFullSize();
      }, 400);
    },
    is_open_left_menu() {
      setTimeout(() => {
        this.updateScreenWrapperOuterFullSize();
      }, 400);
    },
    screen_width(width) {
      this.set_ProjectInfo({
        ScreenSize: {
          width,
        },
      });
      // console.log(this.ProjectInfo);
    },
    screen_height(height) {
      this.set_ProjectInfo({
        ScreenSize: {
          height,
        },
      });
      // console.log(this.ProjectInfo);
    },
    screen_sizeRatio(newVal, oldVal) {
      this.set_ScreenRatio({
        w_Ratio: newVal,
        h_Ratio: newVal,
      });
      this.setRuler();
      this.autoMatchGuideLinePosByRatio(newVal, oldVal);
      this.updateScreenWrapperOuterFullSize();
    },
  },
  methods: {
    ...mapMutations([
      'set_ProjectInfo',
      'set_ThumbNailData',
      'set_ScreenRatio',
      'clearAllChartsFromCurrentScene',
    ]),
    handleImageUploaded(url, fieldName) {
      if (fieldName === 'image') {
        this.templateImageUrl = url;
      }
    },
    handleImageRemoved(fieldName) {
      if (fieldName === 'image') {
        this.templateImageUrl = '';
      }
    },
    onResize() {
      this.setRuler();
      // this.autoFitScreenSize();
      this.updateScreenWrapperOuterFullSize();
    },
    handleTakeAPhotoShot() {
      // let shotDom = document.getElementById('screen-dom');
      // let targetDom = document.getElementById('shot-show');
      // if (shotDom && targetDom) {
      //   console.log('开始截屏！');
      //   html2canvas(shotDom).then(function(canvas) {
      //     targetDom.appendChild(canvas);
      //     console.log('截屏ok！');
      //   });
      // }
    },
    handleAddToTemplate() {
      if (!this.templateName || this.templateName.trim().length < 1) {
        this.$ElMessage.error('请输入模板名称！');
        return;
      }
      let origin_userInfo = window.localStorage.getItem('origin_userInfo');
      // 检查本地登录原始用户信息是否存在
      if (!origin_userInfo) {
        this.$ElMessage.error('用户信息不存在，无法添加！');
        return;
      }

      origin_userInfo = JSON.parse(origin_userInfo);
      let templateimg = this.templateImageUrl;

      let params = {
        method: 'post',
        url: Api.addTemplate,
        data: {
          template_name: this.templateName,
          template_data: JSON.stringify(this.$store.state.ProjectInfo),
          image: templateimg,
          type: this.templateType,
          create_by: origin_userInfo.row_id,
          allow_access_list: this.templateAuth,
        },
        headers: {
          'content-type': 'application/json',
        },
      };

      request(params).then(response => {
        // console.log('添加请求发送成功！');
        console.log(response, '添加请求发送成功！');
        this.$ElMessage.success('添加模板成功！');
        this.isShowComfirmAddToTemplate = false;
      });
    },
    clearCurSeneComponents() {
      this.clearAllChartsFromCurrentScene();
      this.isShowComfirmClearCurSene = false;
      this.$ElMessage.success('清空成功！');
    },
    updateScreenWrapperOuterFullSize() {
      let SWO_dom = document.getElementById('screen-wrapper-outer');
      if (SWO_dom) {
        let getSize = () => {
          let vh = SWO_dom.clientHeight;
          let vw = SWO_dom.clientWidth;
          let swo_rw = SWO_dom.scrollWidth;
          let swo_rh = SWO_dom.scrollHeight;
          // console.log(`vh: ${vh} vw: ${vw} swo_rw: ${swo_rw} swo_rh: ${swo_rh}`);
          this.set_ThumbNailData({
            ViewZoneSize: {
              width: vw,
              height: vh,
            },
            ScreenWrapperOuterFullSize: {
              width: swo_rw,
              height: swo_rh,
            },
          });
          // console.log(this.$store.state.ThumbNailData);
        };
        setTimeout(() => {
          getSize();
        });
      }
    },
    loadLocalGuideLines() {
      let guideLines = window.localStorage.getItem('guideLines');
      if (guideLines) {
        this.guide_lines_sets = JSON.parse(guideLines);
      }
    },
    autoFitScreenSize() {
      // console.log('autoFitScreenSize');
      let workbench_body_dom = document.getElementById('workbench-body');

      if (workbench_body_dom) {
        let { clientWidth: width, clientHeight: height } = workbench_body_dom;
        let wRatio = Math.round((width / this.screen_width) * 100) - 5;
        let hRatio = Math.round((height / this.screen_height) * 100) - 6;
        this.screen_sizeRatio = wRatio >= hRatio ? hRatio : wRatio;

        this.set_ScreenRatio({
          w_Ratio: this.screen_sizeRatio,
          h_Ratio: this.screen_sizeRatio,
        });
      }
    },
    handleScreenSizeRatioMinus() {
      this.isProtectLoalGuideLines = false;
      this.screen_sizeRatio -= 10;
    },
    handleScreenSizeRatioPlus() {
      this.isProtectLoalGuideLines = false;
      this.screen_sizeRatio += 10;
    },
    screenWidthQuerySearch(qs, cb) {
      let data = [
        { value: 1920, desc: '描述' },
        { value: 1680, desc: '描述' },
        { value: 1600, desc: '描述' },
        { value: 1440, desc: '描述' },
        { value: 1280, desc: '描述' },
        { value: 768, desc: '描述' },
      ];
      cb(data);
    },
    screenHeightQuerySearch(qs, cb) {
      let data = [
        { value: 1280, desc: '描述' },
        { value: 1080, desc: '描述' },
        { value: 960, desc: '描述' },
        { value: 768, desc: '描述' },
      ];
      cb(data);
    },
    getCurrentScreenSize() {
      let width = Math.ceil((this.ProjectInfo.ScreenSize.width * this.ProjectInfo.ScreenRatio.w_Ratio) / 100);
      let height = Math.ceil(
        (this.ProjectInfo.ScreenSize.height * this.ProjectInfo.ScreenRatio.h_Ratio) / 100,
      );
      this.set_ThumbNailData({
        ScreenCurrentShowSize: {
          width,
          height,
        },
      });
      return { width: width + 'px', height: height + 'px' };
    },
    // 移动端 视口
    getCurrentScreenMobileSize() {
      let width = Math.ceil((this.ProjectInfo.ScreenSize.width * this.ProjectInfo.ScreenRatio.w_Ratio) / 100);
      let height = Math.ceil(
        (this.ProjectInfo.ScreenSize.height * this.ProjectInfo.ScreenRatio.h_Ratio) / 100,
      );
      console.log(width, height, '移动 屏幕当前实际大小');
      this.set_ThumbNailData({
        // screen当前实际大小
        ScreenCurrentShowSize: {
          width,
          height,
        },
      });

      return { width: width + 'px', height: 844 + 'px' };
      // return { width: width + 'px', height: height + 'px' };
    },

    // 处理辅助线函数
    /* 监听滚动事件调整标尺位置 */
    setRulePosition() {
      let screen_wrapper_outer_dom = document.getElementById('screen-wrapper-outer');
      screen_wrapper_outer_dom.addEventListener('scroll', e => {
        this.autoMatchGuideLineAndRulerPosByScroll(e.target);
        // console.log(e);
        this.screen_wrapper_outer_scrollTop = e.target.scrollTop;
        this.screen_wrapper_outer_scrollLeft = e.target.scrollLeft;
        this.set_ThumbNailData({
          ViewZonePos: {
            top: this.screen_wrapper_outer_scrollTop,
            left: this.screen_wrapper_outer_scrollLeft,
          },
        });
        // console.log(this.$store.state.ThumbNailData);
        // console.log(`this.screen_wrapper_outer_scrollTop ${this.screen_wrapper_outer_scrollTop}`);
        // console.log(`this.screen_wrapper_outer_scrollLeft ${this.screen_wrapper_outer_scrollLeft}`);
      });
    },
    autoMatchGuideLineAndRulerPosByScroll(newdata) {
      /* 滚动时更新标尺位置 */
      this.ruler_top_pos_style = { transform: 'translateX(' + -newdata.scrollLeft + 'px )' };
      this.ruler_left_pos_style = { transform: 'translateY(' + -newdata.scrollTop + 'px )' };
      /* 滚动时更新标尺辅助线位置 */
      this.guide_lines_sets.top.forEach(item => {
        let move_distance = item.origin_scrollLeft - newdata.scrollLeft;
        item.style.transform = 'translateX(' + move_distance + 'px )';
      });
      this.guide_lines_sets.left.forEach(item => {
        let move_distance = item.origin_scrollTop - newdata.scrollTop;
        item.style.transform = 'translateY(' + move_distance + 'px )';
      });
      window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
    },
    setRulerUnit(val) {
      let base = 100;
      if (this.screen_sizeRatio < 100) {
        base = 130;
      }

      if (this.screen_sizeRatio < 90) {
        base = 140;
      }

      if (this.screen_sizeRatio < 70) {
        base = 150;
      }
      this.workbench_rule_unit_long = Math.round(base * (val / 100));
    },
    /* 设置标尺 */
    setRuler() {
      this.ruler_top_scales_arr = [];
      this.ruler_left_scales_arr = [];

      let screen_wrapper_outer_dom = document.getElementById('screen-wrapper-outer');
      if (screen_wrapper_outer_dom) {
        let { scrollHeight, scrollWidth } = screen_wrapper_outer_dom;
        this.setRulerUnit(this.screen_sizeRatio);
        let unit_top = Math.ceil((scrollHeight - 40) / this.workbench_rule_unit_long);
        let unit_left = Math.ceil((scrollWidth - 40) / this.workbench_rule_unit_long);
        for (let i = 0; i <= unit_top + 10; i++) {
          this.ruler_top_scales_arr.push(
            Math.round(i * this.workbench_rule_unit_long * (100 / this.screen_sizeRatio)),
          );
        }
        for (let i = 0; i <= unit_left + 10; i++) {
          this.ruler_left_scales_arr.push(
            Math.round(i * this.workbench_rule_unit_long * (100 / this.screen_sizeRatio)),
          );
        }
      }
    },
    isExistedGuideLine(id) {
      let isExisted = false;
      if (id.startsWith('top')) {
        this.guide_lines_sets.top.forEach(item => {
          if (item.id === id) isExisted = true;
        });
      } else if (id.startsWith('left')) {
        this.guide_lines_sets.left.forEach(item => {
          if (item.id === id) isExisted = true;
        });
      }
      return isExisted;
    },
    handleAddGuideLinesTop(even) {
      this.isProtectLoalGuideLines = false;
      /* 初始化标尺id */
      let id = 'top' + (even.offsetX + 40);
      /* 检查辅助线添加是否重复 */
      if (this.isExistedGuideLine(id)) {
        return;
      }
      let data = {
        id,
        MoveArry: [],
        RatioSum: 1,
        origin_scrollLeft: this.screen_wrapper_outer_scrollLeft,
        origin_scrollTop: this.screen_wrapper_outer_scrollTop,
        origin_left: even.offsetX,
        style: {
          left: even.offsetX - this.screen_wrapper_outer_scrollLeft + 40 + 'px',
          height: Math.round((this.screen_height * this.screen_sizeRatio) / 100) + 40 + 'px',
        },
        markerNum: Math.round((even.offsetX / this.screen_sizeRatio) * 100),
      };
      this.guide_lines_sets.top.push(data);

      window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
    },
    handleWorkbenchTopRulerHover(even) {
      this.isShow_DotsHoverLine_top = true;
      this.dotsHoverLine_topStyle.left = even.offsetX - this.screen_wrapper_outer_scrollLeft + 40 + 'px';
      this.dotsHoverLine_topStyle.markerNum = Math.round((even.offsetX / this.screen_sizeRatio) * 100);
      this.dotsHoverLine_topStyle.height =
        Math.round((this.screen_height * this.screen_sizeRatio) / 100) + 40 + 'px';
    },
    handleAddGuideLinesLeft(even) {
      this.isProtectLoalGuideLines = false;
      let id = 'left' + (even.offsetY + 40);
      /* 检查辅助线添加是否重复 */
      if (this.isExistedGuideLine(id)) {
        return;
      }
      let data = {
        id,
        MoveArry: [],
        RatioSum: 1,
        origin_scrollLeft: this.screen_wrapper_outer_scrollLeft,
        origin_scrollTop: this.screen_wrapper_outer_scrollTop,
        origin_top: even.offsetY,
        style: {
          top: even.offsetY - this.screen_wrapper_outer_scrollTop + 40 + 'px',
          width: Math.round((this.screen_width * this.screen_sizeRatio) / 100) + 40 + 'px',
        },
        markerNum: Math.round((even.offsetY / this.screen_sizeRatio) * 100),
      };
      this.guide_lines_sets.left.push(data);

      window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
    },
    handleWorkbenchLeftRulerHover(even) {
      this.isShow_DotsHoverLine_left = true;
      this.dotsHoverLine_leftStyle.top = even.offsetY - this.screen_wrapper_outer_scrollTop + 40 + 'px';
      this.dotsHoverLine_leftStyle.markerNum = Math.round((even.offsetY / this.screen_sizeRatio) * 100);
      this.dotsHoverLine_leftStyle.width =
        Math.round((this.screen_width * this.screen_sizeRatio) / 100) + 40 + 'px';
    },
    handle_workbench_ruler_hove_end() {
      this.isShow_DotsHoverLine_top = false;
      this.isShow_DotsHoverLine_left = false;
    },
    moveGuideLine(e, id) {
      this.isProtectLoalGuideLines = false;
      const startY = e.clientY;
      const startX = e.clientX;
      let startTop = 0;
      let startLeft = 0;
      let start_markerNum_top = 0;
      let start_markerNum_left = 0;
      if (id.startsWith('top')) {
        let target = this.guide_lines_sets.top.find(item => item.id === id);
        startLeft = parseInt(target.style.left);
        start_markerNum_top = target.markerNum;

        let currX = 0;

        let move = moveEvent => {
          currX = moveEvent.clientX;
          target.markerNum =
            Math.round(((currX - startX) / this.screen_sizeRatio) * 100) + start_markerNum_top;
          target.style.left = currX - startX + startLeft + 'px';
        };
        const up = () => {
          target.MoveArry.push({
            distance: currX - startX,
            his_ratio: this.screen_sizeRatio,
          });
          window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', up);
        };
        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', up);
      } else {
        let target = this.guide_lines_sets.left.find(item => item.id === id);
        startTop = parseInt(target.style.top);
        start_markerNum_left = target.markerNum;

        let currY = 0;

        let move = moveEvent => {
          currY = moveEvent.clientY;
          target.markerNum =
            Math.round(((currY - startY) / this.screen_sizeRatio) * 100) + start_markerNum_left;
          target.style.top = currY - startY + startTop + 'px';
        };
        const up = () => {
          target.MoveArry.push({
            distance: currY - startY,
            his_ratio: this.screen_sizeRatio,
          });
          window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', up);
        };
        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', up);
      }
    },
    removeGuideLine(id) {
      this.isProtectLoalGuideLines = false;
      if (id.startsWith('top')) {
        let index = this.guide_lines_sets.top.findIndex(item => item.id === id);
        this.guide_lines_sets.top.splice(index, 1);
      } else if (id.startsWith('left')) {
        let index = this.guide_lines_sets.left.findIndex(item => item.id === id);
        this.guide_lines_sets.left.splice(index, 1);
      }
      window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
    },
    emptyGuideLines() {
      this.isProtectLoalGuideLines = false;
      this.guide_lines_sets = { top: [], left: [] };
      window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
    },
    toggleLockGuideLinesMove() {
      this.isProtectLoalGuideLines = false;
      this.isPrevent_guideLine_move = !this.isPrevent_guideLine_move;
    },
    toggleHideGuideLines() {
      this.isProtectLoalGuideLines = false;
      this.isHide_guideLines = !this.isHide_guideLines;
    },
    autoMatchGuideLinePosByRatio(newRatio, oldRatio) {
      if (newRatio === undefined && oldRatio === undefined) {
        newRatio = 1;
        oldRatio = 1;
      }

      if (this.isProtectLoalGuideLines === true) {
        return;
      }
      this.guide_lines_sets.top.forEach(item => {
        let movedistance = 0;
        if (item.MoveArry) {
          item.MoveArry.forEach(item => {
            movedistance += Math.round((item.distance * this.screen_sizeRatio) / item.his_ratio);
          });
        }
        item.RatioSum = (item.RatioSum * newRatio) / oldRatio;
        item.style.left =
          Math.round(item.origin_left * item.RatioSum) + movedistance - item.origin_scrollLeft + 40 + 'px';
        item.style.height = Math.round((this.screen_height * this.screen_sizeRatio) / 100) + 40 + 'px';
      });
      this.guide_lines_sets.left.forEach(item => {
        let movedistance = 0;
        if (item.MoveArry) {
          item.MoveArry.forEach(item => {
            movedistance += Math.round((item.distance * this.screen_sizeRatio) / item.his_ratio);
          });
        }
        item.RatioSum = (item.RatioSum * newRatio) / oldRatio;
        item.style.top =
          Math.round(item.origin_top * item.RatioSum) + movedistance - item.origin_scrollTop + 40 + 'px';
        item.style.width = Math.round((this.screen_width * this.screen_sizeRatio) / 100) + 40 + 'px';
      });
      window.localStorage.setItem('guideLines', JSON.stringify(this.guide_lines_sets));
    },
  },
  computed: {
    ...mapState({
      ClientViewSize: state => state.ClientViewSize,
      IndexInfo: state => state.IndexInfo,
      ProjectInfo: state => state.ProjectInfo,
      // isMobile: state => state.isMobile,
    }),
  },
};
</script>

<style lang="scss">
body {
  .el-dialog.index-workbench-dialog {
    background: rgb(32, 33, 43);

    .el-dialog__title {
      color: #ccc;
    }

    .el-dialog__body {
      // height: 50px;
      text-align: center;
      line-height: 50px;
      color: rgb(194, 200, 223);
    }

    .dialog-footer-btns {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 100px;
        color: #fff;
        border: 0;
      }

      .el-button:nth-child(1) {
        background-color: rgb(48, 50, 71);

        &:hover {
          background-color: rgb(39, 44, 63);
        }
      }

      .el-button:nth-child(2) {
        background-color: rgb(191, 40, 111);

        &:hover {
          background-color: rgb(145, 34, 86);
        }
      }
    }
  }
  .el-dialog.index-workbench-addTemplate-dialog {
    background: rgb(32, 33, 43);

    .el-dialog__title {
      color: #ccc;
    }

    .el-dialog__body {
      color: rgb(194, 200, 223);
      padding: 20px 30px;
      box-sizing: border-box;

      .add-template-info {
        width: 100%;

        .add-template-info-item {
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .info-label {
            width: 25%;
          }
          .info-value {
            width: 75%;
            .el-input {
              width: 100%;
            }
            .el-radio__input.is-checked {
              .el-radio__inner {
                background: #3a52c4;
                border: 1px solid #759efe;
                &::after {
                  background: #3a52c4;
                }
              }
            }
            .el-radio__inner {
              background: #676767;
              border: 1px solid #676767;
              &::after {
                background: #676767;
              }
            }
            input {
              height: 30px;
              color: #b6b8cc;
              background: #191b23;
              text-align: center;
              border: 1px solid rgba(139, 139, 139, 0.733);
              &:focus {
                border: 1px solid rgb(77, 91, 255);
              }
            }
          }
        }
      }
    }

    .dialog-footer-btns {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 100px;
        color: #fff;
        border: 0;
      }

      .el-button:nth-child(1) {
        background-color: rgb(48, 50, 71);

        &:hover {
          background-color: rgb(39, 44, 63);
        }
      }

      .el-button:nth-child(2) {
        background-color: rgb(100, 86, 224);

        &:active {
          background-color: rgb(56, 63, 163);
        }
      }
    }
  }
}

body .el-autocomplete__popper.el-popper.screen_size_popper {
  background: #181a1f;
  border: 1px solid #575e62;

  & .el-popper__arrow::before {
    background: #181a1f;
    border: 1px solid #575e62;
  }
  & ul li {
    line-height: 25px;
    text-align: center;
    color: #b6b8cc;
  }
  & ul li:hover {
    background-color: #2c2e3f;
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>
.index-workbench {
  user-select: none;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .workbench-header {
    height: 50px;
    width: 100%;
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    .workbench-size-controller {
      position: absolute;
      display: flex;
      align-items: center;
      left: 50%;
      transform: translateX(-70%);
      padding: 0 10px;

      height: 44px;
      background-color: $background-color-medium;

      .controller_component_btn {
        font-size: 20px;
        cursor: pointer;
        padding: 5px;
        margin: 0 3px;
        border-radius: 3px;
        color: $font-color-base;
        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          color: #fff;
        }
      }
      .screen_sizeRatio_minus_btn {
        cursor: pointer;
        font-size: 20px;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color: $font-color-base;
        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          color: #fff;
        }
      }
      .screen_sizeRatio_info {
        width: 40px;
        text-align: center;
        padding: 0 4px;
        color: $font-color-base;
      }
      .screen_sizeRatio_plus_btn {
        cursor: pointer;
        color: $font-color-base;
        width: 18px;
        height: 18px;
        font-size: 20px;
        line-height: 18px;
        text-align: center;
        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          color: #fff;
        }
      }
      .screen_autofit_btn {
        color: $font-color-base;
        width: 20px;
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        margin: 0 4px;
        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          color: #fff;
        }
      }
      :deep().el-autocomplete input {
        height: 20px;
        color: #b6b8cc;
        background: #000;
        border-color: #636775;
        text-align: center;
        width: 80px;
      }

      .el-icon-close {
        font-size: 14px;
        color: $font-color-base;
      }
      .el-icon-question {
        color: $font-color-base;
        cursor: pointer;
        outline: none;
        padding-left: 5px;
      }
    }
  }
  .workbench-body {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;

    .workbench-rule-component {
      .ban {
        pointer-events: none;
      }
      .guide_line_hide {
        display: none;
      }
      .close {
        position: relative;
        z-index: 999;
        // pointer-events: none;
        background: linear-gradient(
            to top right,
            transparent 0,
            transparent calc(50% - 1.5px),
            #00bcd4 50%,
            transparent calc(50% + 1.5px),
            transparent
          ),
          linear-gradient(
            to bottom right,
            transparent 0,
            transparent calc(50% - 1.5px),
            #00bcd4 50%,
            transparent calc(50% + 1.5px),
            transparent
          );
      }
      position: relative;
      .workbench-ruler-top {
        cursor: pointer;
        position: absolute;
        z-index: 100;
        height: 20px;
        background-color: black;
        top: 0px;
        left: 40px;
        display: flex;
        .rule-scale-top-item {
          flex-shrink: 0;
          height: 20px;
          pointer-events: none;
          text-align: left;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          background-image: repeating-linear-gradient(
              90deg,
              #303133 0,
              #606266 1px,
              transparent 0,
              transparent 100%
            ),
            repeating-linear-gradient(90deg, #606266 0, #303133 1px),
            repeating-linear-gradient(90deg, #303133 0px, #606266 1px, transparent 0, transparent 5%),
            linear-gradient(#000, #000);
          background-position: 0em 100%, 50% 100%, 0 100%, 0 0, 0 0;
          background-size: 100% 100%, 1px 53%, 100% 3px, 100% 100%, 100% 100%;
          background-repeat: no-repeat;
          & p {
            margin: 0;
            padding: 0;
            transform: scale(0.8);
            font-size: 12px;
            transform-origin: 0% 0%;
            margin-left: 5px;
            margin-top: 5px;
          }
        }
      }
      .workbench-ruler-left {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 20px;
        z-index: 10;
        background-color: black;
        top: 40px;
        left: 0px;
        .rule-scale-left-item {
          flex-shrink: 0;
          width: 20px;
          position: relative;
          pointer-events: none;
          text-align: right;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          background-image: repeating-linear-gradient(
              180deg,
              #606266 0px,
              #606266 1px,
              transparent 0px,
              transparent 45%
            ),
            repeating-linear-gradient(180deg, #606266 0, #606266 1px, transparent 0, transparent 50%),
            repeating-linear-gradient(180deg, #606266 0px, #606266 1px, transparent 0, transparent 5%),
            linear-gradient(#000, #000);
          background-position: 0 0, 100% 100%, 100% 100%, 0 0, 0 0;
          background-size: 100% 284%, 40% 100%, 2px 100%, 100% 100%, 100% 100%;
          background-repeat: no-repeat;
          & p {
            margin: 0;
            font-size: 12px;
            padding: 0;
            transform: rotate(90deg) scale(0.8);
            text-align: left;
            user-select: none;
            transform-origin: 0 33%;
            margin-left: 10px;
          }
        }
      }
      .workbench-ruler-manger {
        position: absolute;
        width: 40px;
        height: 40px;
        background-color: #00000000;
        z-index: 100;
        font-size: 13px;
        color: $font-color-base;
        .hide-guide-line-btn {
          // z-index: 9999;
          outline: none;
          cursor: pointer;
          position: absolute;
          width: 20px;
          height: 20px;
          background-color: #2c2e3f;
          box-sizing: border-box;
          line-height: 20px;
          text-align: center;
        }
        .lock-guide-line-btn {
          // z-index: 9999;
          outline: none;
          cursor: pointer;
          left: 20px;
          position: absolute;
          width: 20px;
          height: 20px;
          background-color: #2c2e3f;
          box-sizing: border-box;
          line-height: 20px;
          text-align: center;
          border-bottom: 1px solid #909399;
          border-right: 1px solid #909399;
        }
        .delete-guide-line-btn {
          // z-index: 9999;
          outline: none;
          cursor: pointer;
          top: 20px;
          position: absolute;
          width: 20px;
          height: 20px;
          background-color: #2c2e3f;
          box-sizing: border-box;
          line-height: 20px;
          text-align: center;
          border-bottom: 1px solid #909399;
          border-right: 1px solid #909399;
        }
      }
      .workbench-dash {
        position: absolute;
        top: 0;
        left: 0;
        .workbench-dash-top-item {
          position: absolute;
          width: 10px;
          cursor: ew-resize;
          border-left: 1px solid #409eff;
          z-index: 100;
        }
        .workbench-dash-left-item {
          position: absolute;
          height: 10px;
          cursor: ns-resize;
          border-top: 1px solid #409eff;
          z-index: 100;
        }
        .workbench-dash-top-hover-item {
          pointer-events: none;
          position: absolute;
          width: 10px;
          border-left: 1px dashed #409eff;
          z-index: 100;
        }
        .workbench-dash-left-hover-item {
          pointer-events: none;
          position: absolute;
          height: 10px;
          border-top: 1px dashed #409eff;
          z-index: 100;
        }
        .top-ruler-maker {
          position: absolute;
          left: 5px;
          top: 22px;
          font-size: 14px;
          color: #36dff1;
          background: #1b5e66;
          border-radius: 3px;
          padding: 0 3px;
        }
        .left-ruler-maker {
          position: absolute;
          left: 15px;
          top: 5px;
          font-size: 14px;
          color: #36dff1;
          background: #1b5e66;
          border-radius: 3px;
          padding: 0 3px;
          transform: rotate(90deg);
        }
      }
    }
    .screen-wrapper-outer {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: auto;
      background-image: url('../../assets/img/workbench_bg.png');
      &::-webkit-scrollbar {
        z-index: 0 !important;
        width: 2px;
        height: 2px;
        background-color: #141517;
      }
      &::-webkit-scrollbar-corner {
        z-index: 0;
        background-color: #141517;
      }
      &::-webkit-scrollbar-thumb {
        width: 2px;
        height: 2px;
        z-index: 0 !important;
        background-color: #909399;
      }
      .screen-wrapper {
        position: absolute;
        top: 40px;
        left: 40px;

        padding-bottom: 50px;
        padding-right: 50px;

        .screen {
          // width: 400px;
          // height: 200px;
          // background-color: #464c6b;
          box-shadow: rgb(0 0 0 / 90%) 0 0 30px 0;
        }
      }
    }
    .screen-wrapper-outer-mobile {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: auto;
      background-image: url('../../assets/img/workbench_bg.png');
      .screen-mobile {
        overflow: auto;
      }
      .screen-wrapper {
        position: absolute;
        top: 40px;
        left: 40px;

        padding-bottom: 50px;
        padding-right: 50px;

        .screen {
          // width: 400px;
          // height: 200px;
          // background-color: #464c6b;
          box-shadow: rgb(0 0 0 / 90%) 0 0 30px 0;
        }
      }
    }
    /* .screen-mobile::-webkit-scrollbar { */
    /* 修改滚动条宽度 */
    /* width: 4px;
    /* }
      .screen-mobile::-webkit-scrollbar-thumb {
        border-radius: 8px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #afaeae;
      }
      /* 鼠标移入样式 */
    /* .screen-mobile::-webkit-scrollbar-thumb:hover {
        background: #333333;
      }
      &::-webkit-scrollbar {
        z-index: 0 !important;
        width: 2px;
        height: 2px;
        background-color: #141517;
      }
      &::-webkit-scrollbar-corner {
        z-index: 0;
        background-color: #141517;
      }
      &::-webkit-scrollbar-thumb {
        width: 2px;
        height: 2px;
        z-index: 0 !important;
        background-color: #909399;
      }
      .screen-wrapper {
        position: absolute;
        top: 40px;
        left: 40px;

        padding-bottom: 50px;
        padding-right: 50px;

        .screen {
          // width: 400px;
          // height: 200px;
          // background-color: #464c6b;
          box-shadow: rgb(0 0 0 / 90%) 0 0 30px 0;
        }
      }
    }  */
  }
}
</style>
